import { useCallback, useContext } from 'react';
import { TaskDetailContext } from 'shared/contexts/task-detail/task-detail-context';
import { Options, useKeysDown } from 'shared/hooks/use-keys-down';

// Capture-phase detail shortcuts outrank those of a dialog opened on top of it.
export const useTaskDetailShortcut = (
  keys: string[] | string[][],
  callback: (e: KeyboardEvent, keys: string[]) => void,
  options?: Options,
): void => {
  const { isCoveredByDialog } = useContext(TaskDetailContext);

  const _callback = useCallback(
    (e: KeyboardEvent, pressedKeys: string[]) => {
      if (isCoveredByDialog) {
        return;
      }

      callback(e, pressedKeys);
    },
    [callback, isCoveredByDialog],
  );

  useKeysDown(keys, _callback, options);
};
